<ng-content></ng-content>


// WEBPACK FOOTER //
// ./node_modules/ngx-modal/Modal.d.ts.ModalContent.html